import { render, staticRenderFns } from "./ReceiptTippieFeedback.vue?vue&type=template&id=48e8c0c1&scoped=true&"
import script from "./ReceiptTippieFeedback.vue?vue&type=script&lang=js&"
export * from "./ReceiptTippieFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptTippieFeedback.vue?vue&type=style&index=0&id=48e8c0c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8c0c1",
  null
  
)

export default component.exports